import Vue from 'vue';
import Router from 'vue-router';
import App from './App.vue';
import routes from './routes';
import smoothscroll from 'smoothscroll-polyfill';
import store from './store';
import Pusher from 'pusher-js';
import AppConfig from 'lib/app-config';
import axios from 'lib/axios';
import VueGtag from 'vue-gtag';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
  apiKey: '5d21d23d1932333de5812c428e685d8f',
  plugins: [new BugsnagPluginVue()]
});

Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);

const pusher = new Pusher(AppConfig.pusherKey, { cluster: 'eu' });
window.channel = pusher.subscribe('global');
smoothscroll.polyfill();

Vue.config.productionTip = false;

Vue.directive('visible', (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

Vue.prototype.apiURL = AppConfig.apiURL;
Vue.prototype.$http = axios;

const router = new Router({
  mode: 'history',
  routes: routes.app
});

Vue.use(Router);

Vue.use(VueGtag, {
  config: { id: 'G-9C7Z794S8C' }
});

new Vue({
  router,
  render: h => h(App),
  store: store.app
}).$mount('#app');
